<template>
  <img
    :src="useFullPath ? src : mediaUrl"
    :alt="altText"
    class="pointer-events-none object-cover w-full h-full brightness-70 group-hover:brightness-100 transition-[filter] duration-300 ease-out"
    @error="(event) => event.target.error || (event.target.error = event.target.src = mediaUrl)" />
</template>

<script setup>
import { config } from "@/config";
import { computed } from "vue";

const props = defineProps({
  src: { required: true },
  altText: { required: false },
  placeholder: { default: null },
  useFullPath: { default: false },
});

const mediaBaseURL = config.EVENT_MEDIA_BASE_URL;

const mediaUrl = computed(() => `${mediaBaseURL}/${props.src}`);
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 250ms ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
